import PropTypes from 'prop-types';

import './style.scss';

const Action = ({ txt, handleClick, icon, isBold }) => {
  const Icon = icon;
  return (
    <div
      className={`wrapper-action ${isBold ? 'bold' : ''}`}
      onClick={(e) => {
        handleClick(e);
      }}
    >
      <Icon className="action-icon"></Icon>
      <div className="action-txt">{txt}</div>
    </div>
  );
};

export default Action;

Action.propTypes = {
  txt: PropTypes.string,
  handleClick: PropTypes.func,
  icon: PropTypes.object,
  isBold: PropTypes.bool
};
